import React, { useEffect, useState } from 'react'
import { DropDownWrapper, WellnessHubHeading } from './styles'
import { DropdownContent } from '../../components/UserDashboard/styles'
import { t } from 'i18next'
import { WellnessTabs } from '../../../mockData'
import { BackArrowFeed } from '../../utils/icons';
import { CardContainer } from '../../components/AdventureCategories/styles'
import RelatedContent from '../../components/Article/relatedContent'
import { fetchApi } from '../../utils/methods'
import { toast } from 'react-toastify'
import { NoComments } from '../../components/SocialFeeds/styles'
import { LikeUnlikeEducationPost, UserSavedWellnessContent } from '../../redux/constants/apiConstants'
import PropTypes from 'prop-types';
import FitnessRelatedContent from '../../components/VideoArticle/relatedContent';
import RecipesRelatedContent from '../../components/Recipes/RecipeDetails/relatedContent';

const SavedData = ({ history }) => {
  const [savedArticles, setSavedArticles] = useState([]);
  const [selectedTab, setSelectedTab] = useState({ id: 1, tab: 'Articles', category: 'article' });
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  /* Fetch data when page or tab changes */
  useEffect(() => {
    fetchSavedArticles(selectedTab, page);
    // eslint-disable-next-line
  }, [page, selectedTab]);

  /* Scroll event for infinite scroll */
  useEffect(() => {
    const handleScroll = () => {
      if (loading || !hasMore) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= docHeight - 200) {
        setPage((prev) => prev + 1);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [loading, hasMore]);

  const fetchSavedArticles = async (tab, pageNo) => {
    if (loading || !hasMore) return;

    setLoading(true);

    const payload = {
      type: tab.category,
      id: tab.id,
      page: pageNo,
      per_page: 12
    };

    try {
      const res = await fetchApi(UserSavedWellnessContent, 'POST', payload);
      if (res?.status === 'success') {
        const { results, current_page, last_page } = res.data;

        setSavedArticles((prev) =>
          pageNo === 1 ? results : [...prev, ...results]
        );

        setHasMore(current_page < last_page);
      } else {
        toast.error(res?.error || 'Something went wrong');
      }
    } catch (error) {
      window.console.error(error);
      toast.error('Failed to fetch saved data');
    } finally {
      setLoading(false);
    }
  };

  const onClickFavoriteRibbon = async (type, typeId, likeStatus, favouriteStatus) => {
    const payload = { type, type_id: typeId, like_status: likeStatus, favorite_status: favouriteStatus };

    try {
      const res = await fetchApi("/" + LikeUnlikeEducationPost, "POST", payload);

      if (res.status === "success") {
        setSavedArticles((prev) =>
          prev.map((item) =>
            item.id === typeId ? { ...item, favorite_status: !item.favorite_status } : item
          )
        );
        toast.success(res?.data?.[0]);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("Failed to update favourite");
    }
  };

  const onTabChange = (tab) => {
    setSelectedTab(tab);
    setSavedArticles([]);
    setPage(1);
    setHasMore(true);
  };

  const renderCard = (video) => {
    if (selectedTab.id === 1) {
      return <RelatedContent key={video.id} video={video} history={history} margin="0px 0px 20px 0px" width="calc((100% / 2) - 12.5px)" onClickFavoriteRibbon={onClickFavoriteRibbon} />
    }
    if (selectedTab.id === 2) {
      return <FitnessRelatedContent key={video.id} video={video} history={history} margin="0px 0px 20px 0px" width="calc((100% / 2) - 12.5px)" onClickFavoriteRibbon={onClickFavoriteRibbon} />
    }
    if (selectedTab.id === 3) {
      return <RecipesRelatedContent key={video.id} video={video} history={history} margin="0px 0px 20px 0px" width="calc((100% / 2) - 12.5px)" onClickFavoriteRibbon={onClickFavoriteRibbon} />
    }
    return null;
  };

  return (
    <div style={{ maxWidth: "1246px", padding: "24px 0px 40px 0px", margin: "auto", width: "100%" }}>
      <WellnessHubHeading>
        <div className='right-row'>
          <div className="icon" onClick={() => history.goBack()}>
            {BackArrowFeed("#DA6C74")}
          </div>
          <div className="title">{t("Saved Data")}</div>
        </div>
      </WellnessHubHeading>

      <DropDownWrapper>
        {WellnessTabs?.map((data, index) => (
          <DropdownContent key={index} userInterest={selectedTab.id === data.id} onClick={() => onTabChange(data)}>
            <div className="listContent">{data?.tab}</div>
          </DropdownContent>
        ))}
      </DropDownWrapper>

      <CardContainer style={{justifyContent:'unset'}}>
        {!savedArticles?.length && !loading ? (
          <NoComments>{t(`No Saved ${selectedTab.tab}`)}</NoComments>
        ) : (
          savedArticles.map(renderCard)
        )}
      </CardContainer>

      {loading && <NoComments>{t('Loading more...')}</NoComments>}
    </div>
  )
}

SavedData.propTypes = {
  history: PropTypes.object.isRequired
};

export default SavedData;
